import LoqateInternalApiClient from './LoqateInternalApiClient';
import LoqateAutofill from './LoqateAutofill';
import DaumPostalServiceClient from './DaumPostalServiceClient';
import DaDataApiClient from './DaDataApiClient';
import PostCodeNLApiClient from './PostCodeNLApiClient';
import ExperianApiClient from './ExperianApiClient';
import DeutschePostApiClient from './DeutschePostApiClient';

export const ADDRESS_SERVICE_PROVIDERS = {
  LOQATE_INTERNAL: 'LOQATE_INTERNAL',
  DAWA: 'DAWA',
  LOQATE_AUTOFILL: 'LOQATE_AUTOFILL',
  DAUM_POSTAL_SERVICE: 'DAUM_POSTAL_SERVICE',
  DA_DATA: 'DA_DATA',
  POSTCODE_NL: 'POSTCODE_NL',
  EXPERIAN: 'EXPERIAN',
  DEUTSCHE_POST: 'DEUTSCHE_POST'
};

export const AddressApiClients = {
  [ADDRESS_SERVICE_PROVIDERS.LOQATE_INTERNAL]: LoqateInternalApiClient,
  [ADDRESS_SERVICE_PROVIDERS.DAWA]: LoqateInternalApiClient,
  [ADDRESS_SERVICE_PROVIDERS.LOQATE_AUTOFILL]: LoqateAutofill,
  [ADDRESS_SERVICE_PROVIDERS.DAUM_POSTAL_SERVICE]: DaumPostalServiceClient,
  [ADDRESS_SERVICE_PROVIDERS.DA_DATA]: DaDataApiClient,
  [ADDRESS_SERVICE_PROVIDERS.POSTCODE_NL]: PostCodeNLApiClient,
  [ADDRESS_SERVICE_PROVIDERS.EXPERIAN]: ExperianApiClient,
  [ADDRESS_SERVICE_PROVIDERS.DEUTSCHE_POST]: DeutschePostApiClient
};
